<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item, index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control == "Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control == "Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control == "Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control == "Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control == "Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control == "Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control == "File"' :data-val="item"></File>
			<Table v-if='item.Property.Control == "Table"' @child-event='tableOperation' :data-val='item'
				:template-data='templateData'></Table>
			<Selector v-if='item.Property.Control == "Selector"' @child-event='getSelectorVal' :data-val='item'>
			</Selector>
			<Textarea v-if='item.Property.Control == "Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control == "Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from '../components/Number.vue'
import Contact from '../components/Contact.vue';
import Dates from '../components/Date.vue';
import Version from '../components/Text.vue';
import Money from '../components/Money.vue';
import Tips from '../components/Tips.vue';
import File from '../components/File.vue';
import Table from '../components/Table.vue';
import Selector from '../components/Selector.vue';
import Textarea from '../components/Textarea.vue';
import Choose from '../components/Choose.vue';
import wx from 'weixin-js-sdk'
import stringUtils from "../assets/js/stringUtil.js";
import {
	initWxConfig
} from '../api/jssdk.js';
import {
	getTemplateInfo,
	submitProcess,
	sendMessage
} from '@/api/approval'
import {
	getDepartmentRelationByName,
	getDepartmentRelationById,
	getDepartmentInfo
} from '@/api/department'
import {
	getRelation
} from '@/api/employee'

var isSubmit = false;

var template = {
	TemplateContent: {
		Controls: []
	}
};
const sendMessagetTemplate = {
	title: null,
	url: null,
	toUser: [],
	desc: null,
	template: null,
};
export default {
	components: {
		Contact,
		Dates,
		Version,
		Money,
		Tips,
		File,
		Table,
		Digit,
		Selector,
		Textarea,
		Choose
	},
	data() {
		return {
			templateData: template,
			relationList: null,
			logInfo: null,
			templateId: "",
			spNo: null,
			sendMessageData: Object.assign({}, sendMessagetTemplate),
			formLoading: false,
			listLoading: false,
			flowId: null
		}
	},
	created() {
		initWxConfig(this);
		this.logInfo = this.getLoginUserInfo();
		this.templateId = this.$route.query.templateId;
		this.flowId = this.$route.query.flowId;
		this.getTemplate();
		stringUtils.setAddIsShow(true);
	},
	methods: { //方法

		clickChoose: async function (dataVal, name) {
			var that = this;
			window.wx.invoke("selectEnterpriseContact", {
				"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
				"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
				"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
				"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
			}, async function (res) {
				if (res.err_msg == "selectEnterpriseContact:ok") {
					if (typeof res.result == 'string') {
						res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
					}
					var depart = res.result.departmentList[0]; // 已选的部门列表
					dataVal.Values = [];
					dataVal.Value = depart.name;
					dataVal.Values.push([depart.id, depart.name]);

					getDepartmentInfo(depart.id).then(async res => {
						var departFullName = res.Body.FullName;
						var ApiDep = departFullName;
						var departName = departFullName.split("/");
						that.templateData.TemplateContent.Controls.forEach(async (item, index) => {
							var datas = [];
							if (item.Property.Title[0].Text == "大区总经理") {
								item.Values = [];
								item.Values = await that.getDepartmentRelation(depart.id, "总经理", true);
								if (item.Values == null || item.Values.length <= 0) {
									//审批节点无人，跳过
									item.Values.push(["SC24000029", "钟志斌"]);
								}
							}
							if (item.Property.Title[0].Text == "大区董事") {
								item.Values = [];
								item.Values = await that.getDepartmentRelation(depart.id, "大区董事", true);
								if (item.Values == null || item.Values.length <= 0) {
									//审批节点无人，跳过
									item.Values.push(that.$store.state.defaultMember);
								}
							}
							if (departName.indexOf("二级市场支援中心") > -1) {
								if (item.Property.Title[0].Text == "流程条件") {
									item.Value = 7;
								}
							}
							else if (departName.indexOf("新媒体中心") > -1) {
								if (item.Property.Title[0].Text == "流程条件") {
									item.Value = 8;
								}
							}
							else if (departName.indexOf("非营业部") > -1) {
								if (item.Property.Title[0].Text == "逐级审批") {
									item.Values = [];
									item.IsShow = false;
									await getDepartmentRelationById(res.Body.DeptId).then(data => {
										if (data.Body != null && data.Body.length > 0) {
											for (var i = 0; i < data.Body[0].Nodes.length; i++) {
												var depData = data.Body[0].Nodes[i];
												if (depData.DeptName == "非营业部") {
													break;
												}
												if (depData.Items != null) {
													depData.Items.sort(function (a, b) {
														return a.JobLevel - b.JobLevel
													})
													depData.Items.forEach((userData) => {
														if (userData.EmpNo != 'SC02120002') {
															var insertDat = [userData.EmpNo, userData.EmpName]
															item.Values.push(insertDat);
														}

													})
												}
											}

										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length == 0) {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
									});
								}
								if (item.Property.Title[0].Text == "流程条件") {
									item.Value = 1;
								}
							} else if (departName.indexOf("原友信") > -1) {
								if (item.Property.Title[0].Text == "流程条件") {
									item.Value = 1;
								}
								if (item.Property.Title[0].Text == "逐级审批") {
									await getDepartmentRelationByName(departFullName, true).then(async response => {
										if (response.Body != null) {
											datas = response.Body[0].Nodes;
										}
									})
									item.Values = that.getRelationList(datas, 8);
									for (let i = item.Values.length - 1; i > -1; i--) {
										if (item.Values[i][0] == 'SC02120002') {
											item.Values.splice(i, 1);
										}
									}

									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(that.$store.state.defaultMember);
									}
								}

							} else if (departName.indexOf("二级市场营运中心") > -1 || departName.indexOf("代理") > -1) {
								if (item.Property.Title[0].Text == "流程条件") {
									item.Value = 2;
								}
								if (item.Property.Title[0].Text == "逐级审批") {
									await getDepartmentRelationByName(departFullName, true).then(async response => {
										if (response.Body != null) {
											datas = response.Body[0].Nodes;
										}
									})
									item.Values = that.getRelationList(datas, 8);
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(that.$store.state.defaultMember);
									}
								}
							} else if (departName.indexOf("房友圈") > -1||departName.indexOf("藤云") > -1){
								if (item.Property.Title[0].Text == "流程条件") {
									item.Value = 3;
								}
								if (item.Property.Title[0].Text == "逐级审批") {
									await getDepartmentRelationByName(departFullName, true).then(async response => {
										if (response.Body != null) {
											datas = response.Body[0].Nodes;
										}
									})
									item.Values = that.getRelationList(datas, 7);
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(that.$store.state.defaultMember);
									}
								}
							} else if (departName.indexOf("工商铺商业运营中心") > -1) {
								if (item.Property.Title[0].Text == "流程条件") {
									item.Value = 4;
								}
								if (item.Property.Title[0].Text == "逐级审批") {
									await getDepartmentRelationByName(departFullName, true).then(async response => {
										if (response.Body != null) {
											datas = response.Body[0].Nodes;
										}
									})
									item.Values = that.getRelationList(datas, 6);

									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(that.$store.state.defaultMember);
									}
								}
							} else if (departName.indexOf("住宅部") > -1) {
								if (item.Property.Title[0].Text == "流程条件") {
									item.Value = 5;
								}
								if (item.Property.Title[0].Text == "逐级审批") {
									await getDepartmentRelationByName(departFullName, true).then(async response => {
										if (response.Body != null) {
											datas = response.Body[0].Nodes;
										}
									})
									item.Values = that.getRelationList(datas, 6);
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(that.$store.state.defaultMember);
									}
								}
							} else if (departName.indexOf("按揭金融服务中心") > -1) {
								if (item.Property.Title[0].Text == "流程条件") {
									item.Value = 6;
								}
								if (item.Property.Title[0].Text == "逐级审批") {
									await getDepartmentRelationByName(departFullName, true).then(async response => {
										if (response.Body != null) {
											datas = response.Body[0].Nodes;
										}
									})
									item.Values = that.getRelationList(datas, 7);
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(that.$store.state.defaultMember);
									}
								}
							}
						})
					});
				}
			})
		},
		getTemplate: async function () {
			this.listLoading = true;
			var title = this.logInfo.fullName;
			var jobLevel = this.logInfo.JobLevel;
			await getTemplateInfo(this.templateId).then(async response => {
				var controls = response.Body;
				await this.getEmployeeRelation();
				controls.TemplateContent.Controls.forEach(async (item, index) => {
					var departs = this.logInfo.fullName.split("/");
					if (item.Property.Control == "Table") {
						for (var i = 0; i < item.Config.Table.Children.length; i++) {
							var childItem = item.Config.Table.Children[i];
							if (childItem.Property.Title[0].Text == "预计金额") {
								childItem.Disable = true;
								break;
							}
						}
					}
					if (item.Property.Title[0].Text == "请选择审批流程") {
						item.IsShow = false;
						if (departs.indexOf("住宅部") > -1) {
							item.Value = item.Config.Selector.Options.filter(item => {
								return item.Value[0].Text == "1"
							})[0].Key;
						} else if (departs.indexOf("住宅行政支持组") > -1) {
							//分行行政
							item.Value = item.Config.Selector.Options.filter(item => {
								return item.Value[0].Text == "2"
							})[0].Key;
						} else if (departs.indexOf("房友圈") > -1) {
							if (departs.indexOf("后勤房友圈") > -1) {
								item.Value = item.Config.Selector.Options.filter(item => {
									return item.Value[0].Text == "2"
								})[0].Key;
							} else {
								item.Value = item.Config.Selector.Options.filter(item => {
									return item.Value[0].Text == "1"
								})[0].Key;
							}
						} else if (departs.indexOf("华西区") > -1) {
							if (departs.indexOf("华西区信息中心") > -1) {
								item.Value = item.Config.Selector.Options.filter(item => {
									return item.Value[0].Text == "2"
								})[0].Key;
							} else {
								item.Value = item.Config.Selector.Options.filter(item => {
									return item.Value[0].Text == "1"
								})[0].Key;
							}
						}
					}

					if (item.Property.Title[0].Text == "合计") {
						item.Disable = true;
					}
					if (item.Property.Title[0].Text == "小计") {
						item.Disable = true;
					}
					if (item.Property.Title[0].Text == "行政主任") {
						item.Values = []
						item.Values.push(this.$store.state.defaultMember);
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "行政经理") {
						item.Values = []
						item.Values.push(this.$store.state.defaultMember);
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "大区董事") {
						item.Values = []
						item.Values.push(this.$store.state.defaultMember);
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "大区总经理") {
						item.Values = []
						item.Values.push(this.$store.state.defaultMember);
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "总经理") {
						item.Values = []
						item.Values.push(this.$store.state.defaultMember);
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "经理/总监") {
						item.Values = []
						item.Values.push(this.$store.state.defaultMember);
						item.IsShow = false;
					}

					if (item.Property.Title[0].Text == "维修") {
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "逐级审批") {
						item.IsShow = false;
						item.Values = [
							["SC24000029", "钟志斌"]
						]
					}
					if (item.Property.Title[0].Text == "申请人员部门") {
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "姓名") {
						item.Disable = true;
					}
				});
				this.templateData = this.assignControl(controls, this.logInfo);
				this.templateData = await this.assignControlBySpNo(controls, null, this.flowId);
				this.listLoading = false;
			});

		},
		getEmployeeRelation: async function () {
			await getRelation(this.logInfo.EmpNo).then(response => {
				this.relationList = response.Body[0].Nodes;
			});
		},
		getTextVal() { },
		getSelectorVal(val, name) {
			if (name == "类别") {
				var controls = this.templateData.TemplateContent.Controls;
				var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
				var option = controlInfo.Config.Selector.Options
					.filter(item => {
						return item.Value[0].Text == "维修" && val.indexOf(item.Key) > -1;
					})[0];
				var control = controls.filter(item => item.Property.Title[0].Text == "维修")[0];
				if (option != null) {
					control.IsShow = true;
					control.Property.Require = 1;
				} else {
					control.IsShow = false;
					control.Property.Require = 0;
				}
			}
		},
		tableOperation(val, type, datas) {
			this.tableoperation(val, type, datas, this);
		},
		submit() {
			var isOk = true;
			this.templateData.TemplateContent.Controls.forEach(e => {
				if (e.Property.Title[0].Text == "逐级审批") {
					if (e.Values == null || e.Values.length == 0 || e.Values[0][0] == 'SC24000029') {
						/* if (!confirm('选择的部门没有负责人,点击"ok"继续提交')) {
							isOk = false;
						} */
						if (e.Values == null || e.Values.length == 0) {
							e.Values = [this.$store.state.defaultMember];
						}
					}
				}
			})
			if (!isOk) {
				return;
			}
			//数据校验
			if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
				return;
			}
			if (isSubmit) {
				this.Message({
					message: '已提交',
					type: 'warning',
					duration: 1000
				});
				return;
			}
			isSubmit = true;

			//提交
			submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData, this.flowId).then(response => {
				this.Message({
					message: '申请成功',
					type: 'success',
					duration: 3 * 1000
				});
				setTimeout(() => {
					this.$router.push("/index");
				}, 3000)
			}).finally(() => {
				isSubmit = false;
				this.listLoading = false;
			});
		}
	}

}
</script>

<style scoped lang="less">
.pages {
	padding-bottom: 14px;
}
</style>
